import { createRoutine } from 'redux-saga-routines'

export const LOCALIZATION_SETLOCALE = "Localization.SetLocale";
export const LOCALIZATION_LOAD_TRANSLATION = "Localization.LoadTranslation";

export const setLocale = createRoutine(LOCALIZATION_SETLOCALE);
export const loadTranslation = createRoutine(LOCALIZATION_LOAD_TRANSLATION);
